import { useSyncExternalStore } from 'react';

// Mismo corte que el `lg` de Tailwind (64rem): la carcasa elige qué navegación montar
// (riel en escritorio, barra superior y menú en el celular) con la misma regla que el CSS
// usa para mostrarlas, así nunca quedan las dos ocultas ni las dos montadas.
const DESKTOP_QUERY = '(min-width: 64rem)';

let desktopMedia: MediaQueryList | undefined;
const getDesktopMedia = (): MediaQueryList => (desktopMedia ??= window.matchMedia(DESKTOP_QUERY));

const subscribe = (onChange: () => void): (() => void) => {
  const media = getDesktopMedia();
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

const getSnapshot = (): boolean => getDesktopMedia().matches;
const getServerSnapshot = (): boolean => false;

/**
 * `true` desde el ancho de escritorio (`lg`). Sincronizado con `useSyncExternalStore`:
 * el primer render ya lee el valor real (sin un render intermedio con el valor por
 * defecto que haga parpadear la navegación) y al cruzar el corte se actualiza en el
 * mismo cuadro que el CSS.
 */
export const useIsDesktop = (): boolean => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
